// Curated YouTube Shorts / videos shown in the "Watch Us Work" section.
// To add / change videos:
//   1. Open the video on YouTube.
//   2. Copy the video ID — it's the part after `?v=` on a normal video
//      (e.g. youtube.com/watch?v=ABC123xyz → id is "ABC123xyz"),
//      or the part after `/shorts/` for a Short
//      (e.g. youtube.com/shorts/ABC123xyz → id is "ABC123xyz").
//   3. Add an object to the VIDEOS array below.
//
// Shorts are vertical (9:16). Regular videos are horizontal (16:9).
// Mark `kind: "short"` for vertical Shorts so the card is rendered tall.

export const VIDEOS = [
  { id: "XBBzXe0bCGs", title: "On the job — All Day Power Washing", kind: "short" },
  { id: "_-9xGnkoHKY", title: "Heavy-duty clean in action", kind: "short" },
  { id: "bVUaGX7_GFg", title: "Before & after transformation", kind: "short" },
  { id: "TOnqk71rK9Y", title: "Pressure washing that delivers", kind: "short" },
];

export const YT_CHANNEL_URL =
  "https://www.youtube.com/@AllDayPowerWashing-oy3vw";
